import { render, staticRenderFns } from "./ScreeningDocumentList.vue?vue&type=template&id=7d23177c"
import script from "./ScreeningDocumentList.vue?vue&type=script&lang=ts"
export * from "./ScreeningDocumentList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports